module.exports = __webpack_public_path__ + "img/dna-report-result-push-notif.c1f389a.png";